import { Defaults, RecruitmentAgency, TRecruitmentAgency } from "@timesheets/constants-common";

import { WebApplicationConstants } from "../setup/WebApplicationConstants";
import { WireEntities } from "@timesheets/common";
import { getBrandingDescriptor } from "@gemma/web-common";
import { getTenantInfo } from "@gemma/web-common";

export function setTenantColors(tenantName: string, colors: WireEntities.Session.TSessionBranding["colors"]): void {
  const tenantInfo = getTenantInfo(window.location.hostname, { domainPrefix: WebApplicationConstants.domainPrefix, subZone: WebApplicationConstants.subZone });
  const setAsDefault = tenantName === tenantInfo.canonicalTenantName;

  const brandingDescriptor = getBrandingDescriptor(tenantName);
  setColor(brandingDescriptor, colors, RecruitmentAgency.ColorTypes.Primary, setAsDefault);
  setColor(brandingDescriptor, colors, RecruitmentAgency.ColorTypes.Secondary, setAsDefault);
}

function setColor(brandingDescriptor: string, colors: WireEntities.Session.TSessionBranding["colors"], type: TRecruitmentAgency["TColorTypes"], setAsDefault: boolean): void {
  const defaultColors = Defaults.getColors();
  let colorSet = colors[type];
  if (!colorSet) {
    colorSet = Object.assign({}, defaultColors[type]);
  }

  if (!colorSet.main) {
    colorSet.main = defaultColors[type].main;
  }

  if (!colorSet.text) {
    colorSet.text = defaultColors[type].text;
  }

  const mainString = "--" + type + "-main-color-" + brandingDescriptor;
  const main = document.documentElement.style.getPropertyValue(mainString);
  if (!main || main !== colorSet.main) {
    document.documentElement.style.setProperty(mainString, colorSet.main);
  }

  const textString = "--" + type + "-text-color-" + brandingDescriptor;
  const text = document.documentElement.style.getPropertyValue(textString);
  if (!text || text !== colorSet.text) {
    document.documentElement.style.setProperty(textString, colorSet.text);
  }

  if (setAsDefault) {
    const mainString = "--" + type + "-main-color";
    const main = document.documentElement.style.getPropertyValue(mainString);
    if (!main || main !== colorSet.main) {
      document.documentElement.style.setProperty(mainString, colorSet.main);
    }

    const textString = "--" + type + "-text-color";
    const text = document.documentElement.style.getPropertyValue(textString);
    if (!text || text !== colorSet.text) {
      document.documentElement.style.setProperty(textString, colorSet.text);
    }
  }
}
